module.exports = __webpack_public_path__ + "static/media/animate.9e3bc271.svg";